import { useEffect, useRef } from "react";

/**
 * @description: This custom hook receives a function as a parameter and runs it when the user leaves the page
 *
 * @param _function: Function
 */
export const useBeforeLeave = (_function: any) => {
    const callbackRef = useRef(_function);
  
    useEffect(() => {
      const onUnload = callbackRef.current;
      window.addEventListener('beforeunload', onUnload);
      return () => {
        window.removeEventListener('beforeunload', onUnload);
      };
    }, [callbackRef]);
  };